
import AppSwitch from '@/components/common/Switch';
import Paragraph from '@/components/typography/Paragraph.vue';
export default {
  components: { AppSwitch, Paragraph },
  props: {
    onCancel: { type: Function, default: () => {} },
    onSave: { type: Function, default: () => {} },
    fields: { type: Array, default: () => [] },
    fieldsSize: { type: String, default: 'large' },
  },

  data() {
    return {
      changes: [],
      hasError: false,
    };
  },

  computed: {
    filteredData() {
      return this.changes.reduce((acc, change) => ({ ...acc, [change.id]: change.value }), {});
    },
  },

  watch: {
    fields(data) {
      this.changes = this.parseFields(data);
    },
  },

  methods: {
    parseFields(fields) {
      return (fields || []).map((field) => {
        const { id, label, placeholder, required, validationErrorText, value } = field;

        return {
          ...field,
          label: (label || id || '') + (required ? '*' : ''),
          value: value ?? '',
          options: field.options || [],
          placeholder: placeholder || 'Text',
          validationErrorText: validationErrorText || 'This field is required.',
          hasError: required && this.isFaultState(field),
          touched: false,
        };
      });
    },

    onChange(changeObj) {
      changeObj.hasError = changeObj.required && this.isFaultState(changeObj);
      changeObj.touched = true;
      this.hasError = this.changes.some((entity) => entity.hasError);

      this.$emit('change', {
        data: this.filteredData,
        hasError: this.hasError,
        hasChange: true,
      });
    },

    changeBoolean(change) {
      change.value = !change.value;
      this.onChange(change);
    },

    isFaultState({ value, type }) {
      switch (value) {
        case false:
          return type !== 'boolean';
        default:
          return !value;
      }
    },
  },
};
